export default __webpack_public_path__ + "static/media/a-t.9575c5a2.jpg";